module.exports = __webpack_public_path__ + "media/images/plans/plan-detail-photo-bg-color-26bffe5c6568d3352ec1c4be641ecc6a.jpg";